import { render } from "./CardIdioma.vue?vue&type=template&id=57cd1929&scoped=true"
import script from "./CardIdioma.vue?vue&type=script&lang=js"
export * from "./CardIdioma.vue?vue&type=script&lang=js"

import "./CardIdioma.vue?vue&type=style&index=0&id=57cd1929&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cd1929"]])

export default __exports__